import React from 'react';

import { BaseIconProps } from '.';

export const BellSimple = ({ fill }: BaseIconProps) => (
  <g
    transform="matrix(56.842105,0,0,56.842105,56.842108,2.5000002e-6)"
    strokeWidth="0.01759259"
  >
    <path
      fill={fill}
      strokeWidth="0.01759259"
      d="m 13.222,8.143 c 0,-2.499 -2.114,-4.524 -4.722,-4.524 -2.608,0 -4.722,2.025 -4.722,4.524 v 6.333 h 9.444 z M 17,16.286 H 0 v -0.905 l 1.889,-1.81 V 8.143 c 0,-2.802 1.92,-5.27 4.722,-6.071 a 2.47,2.47 0 0 1 0,-0.262 C 6.611,0.81 7.457,0 8.5,0 c 1.043,0 1.889,0.81 1.889,1.81 0.005,0.087 0.005,0.174 0,0.262 2.802,0.8 4.723,3.27 4.722,6.07 v 5.43 L 17,15.38 Z M 6.611,17.19 h 3.778 C 10.389,18.19 9.543,19 8.5,19 7.457,19 6.611,18.19 6.611,17.19 Z"
    />
  </g>
);
